
const ErrorMessage = ({ message }) => {
  if (message) {
    return <div className='text-red-500 mt-2 font-medium'>{message}</div>
  }

  return <></>
}

export default ErrorMessage
